var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-3"},[_c('ski-round-button',{staticClass:"d-print-none",attrs:{"text":_vm.shortcutText,"to":_vm.shortcutLink,"flex-style":_vm.flexStyling}},[_vm._t("icon",[_c('environment',{staticClass:"svg"})])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }